import { isString } from 'lodash/fp';
import { TableType, ShareType, JobRunTriggerType } from 'app/lib/types/server';
import {
    DATA_SOURCE_REFERENCE_DTO_TYPE,
    VIEW_REF_DTO_TYPE,
    SQL_VIEW_DTO_TYPE,
    TRANSFORMATION_STACK_DTO_TYPE,
    QUERY_BUILDER_TYPE,
    COMBINE_TYPE,
    JOIN_TYPE,
    BLEND_DTO_TYPE,
    REPLACE_DTO_TYPE,
    SPLIT_DTO_TYPE,
    SUBSTRING_EXTRACT_DTO_TYPE,
    PROJECT_DTO_TYPE,
    FORMULA_DTO_TYPE,
    PIVOT_DTO_TYPE,
    AGGREGATION_DTO_TYPE,
    FILTER_DTO_TYPE,
    MODEL_DTO_TYPE,
    DRAFT_MODEL_DTO_TYPE
} from 'app/store/__generated__/types';
import { GET_SPACE_SUCCESS_SPACE_DTO } from 'app/store/__generated__/events';
import {
    DATMEER_CONNECTION,
    EXTRACT_JSON,
    GROUP_NODE,
    JOBS,
    LOCAL_FILE_CONNECTION,
    SNOWFLAKE_CONNECTION,
    SOURCE_NOT_AVAILABLE,
    UPLOAD_CONNECTION,
    FILTER,
    MULTI_JOIN,
    ERROR_NODE
} from 'app/lib/constants';

type IconsMap = {
    [key: string]: string;
};

const ICONS_MAP: IconsMap = {
    [DATA_SOURCE_REFERENCE_DTO_TYPE]: 'datasource-reference',
    [VIEW_REF_DTO_TYPE]: 'datasource-reference',
    [TRANSFORMATION_STACK_DTO_TYPE]: 'transform-stack',
    [GET_SPACE_SUCCESS_SPACE_DTO]: 'dataspace',
    [JOBS]: 'job',
    // transformations
    [SQL_VIEW_DTO_TYPE]: 'op-sql',
    [COMBINE_TYPE]: 'op-union',
    [BLEND_DTO_TYPE]: 'op-blend',
    [JOIN_TYPE]: 'op-blend',
    [EXTRACT_JSON]: 'op-extract-json',
    [QUERY_BUILDER_TYPE]: 'explore',
    [FILTER_DTO_TYPE]: 'filter',
    [REPLACE_DTO_TYPE]: 'op-replace',
    [SPLIT_DTO_TYPE]: 'op-split',
    [SUBSTRING_EXTRACT_DTO_TYPE]: 'op-extract',
    [PROJECT_DTO_TYPE]: 'op-manage-columns',
    [FORMULA_DTO_TYPE]: 'function',
    [AGGREGATION_DTO_TYPE]: 'aggregate',
    [PIVOT_DTO_TYPE]: 'pivot',
    [FILTER]: 'filter',
    [MULTI_JOIN]: 'op-blend',
    // Trigger types
    [JobRunTriggerType.SCHEDULED]: 'type-time',
    [JobRunTriggerType.DATA_DRIVEN]: 'data-trigger',
    [JobRunTriggerType.MANUAL]: 'profile',
    // Shares
    [ShareType.EMAIL]: 'mail',
    [ShareType.GOOGLE_SHEETS]: 'google',
    [GROUP_NODE]: 'flow',
    [TableType.VIEW]: 'view',
    [TableType.TABLE]: 'table',
    [DATMEER_CONNECTION]: 'datameer',
    [LOCAL_FILE_CONNECTION]: 'upload',
    [UPLOAD_CONNECTION]: 'upload',
    [SNOWFLAKE_CONNECTION]: 'snowflake',
    [SOURCE_NOT_AVAILABLE]: 'source-not-available',
    [DRAFT_MODEL_DTO_TYPE]: 'draft-model',
    [MODEL_DTO_TYPE]: 'model-table',
    [ERROR_NODE]: 'error-solid'
};

export function resolveIconForType(type?: string | null) {
    if (!type || !isString(type)) {
        return 'blank';
    }
    return ICONS_MAP[type] ?? `type-${type.toLowerCase()}`;
}
